<div class="container">
    <div class="justify-content-center mt-5 row">
        <div class="col-sm-10 col-md-8 ">
            <div class="card" *ngIf="!isLoading">
                <div class="card-body">
                    <div class="card-title mb-3">
                        <h4 class="text-center">Create a Q2E GateCube Account</h4>
                    </div>
                    <form [formGroup]="rgFrmGrp" (ngSubmit)="onSubmitMemberInfo()">
                        <div class="form-group">
                            <label for="name">Name:</label>
                            <input type="text" formControlName="name" id="name" class="form-control" placeholder=""
                                required
                                [ngClass]="{ 'is-invalid': f.name.touched && f.name.errors, 'is-valid': f.name.valid }">
                            <div *ngIf="f.name.touched && f.name.errors" class="invalid-feedback">
                                <div *ngIf="f.name.errors.required">Name is required!</div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="name">Email:</label>
                            <input type="text" formControlName="emailId" id="emailId" class="form-control" placeholder=""
                                required [ngClass]="{ 'is-invalid': f.emailId.touched && f.emailId.errors, 'is-valid': f.emailId.valid }">
                            <div *ngIf="f.emailId.touched && f.emailId.errors" class="invalid-feedback">
                                <div *ngIf="f.emailId.errors.required">Email Id is required!</div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="name">Company Name:</label>
                            <input type="text" formControlName="companyName" id="companyName" class="form-control"
                                placeholder="" required
                                [ngClass]="{ 'is-invalid': f.companyName.touched && f.companyName.errors, 'is-valid': f.companyName.valid }">
                            <div *ngIf="f.companyName.touched && f.companyName.errors" class="invalid-feedback">
                                <div *ngIf="f.companyName.errors.required">Company Name is required!</div>
                            </div>
                        </div>

                        <div class="form-group" *ngIf="isNew">
                            <label for="newPassword">Password:</label>
                            <input type="password" class="form-control" id="newPassword" placeholder=""
                                name="newPassword" formControlName="newPassword" required (input)="onPasswordInput()"
                                [ngClass]="{ 'is-invalid': f.newPassword.touched && f.newPassword.errors, 'is-valid': f.newPassword.valid }">
                            <div class="invalid-feedback">
                                <span *ngIf="newPassword.hasError('required')">Password is required.</span>
                                <span *ngIf="newPassword.hasError('minlength')">Password must have at least {{minPw}}
                                    characters.</span>
                            </div>


                        </div>
                        <div class="form-group" *ngIf="isNew">
                            <label for="confirmPassword">Confirm Password:</label>
                            <input type="password" class="form-control" id="confirmPassword" placeholder=""
                                name="confirmPassword" formControlName="confirmPassword" required
                                (input)="onPasswordInput()"
                                [ngClass]="{ 'is-invalid': f.confirmPassword.touched && f.confirmPassword.errors, 'is-valid': f.confirmPassword.valid }">
                            <div class="invalid-feedback">
                                <span *ngIf="confirmPassword.hasError('required')">Please confirm your password.</span>
                                <span *ngIf="f.confirmPassword.touched && f.confirmPassword.errors">Passwords don't
                                    match.</span>
                            </div>
                        </div>

                        <small class="text-danger">{{msg}}</small>

                        <div class="form-group" *ngIf="isNew">
                            <div class="row">
                                <div class="col-md-12">
                                    <button type="submit" [disabled]="rgFrmGrp.invalid || inProcess" class="btn btn-primary float-right" style="width: 200px;">
                                        <span *ngIf="inProcess" class="spinner-border spinner-border-sm mr-1"></span>Create</button>
                                </div>
                            </div>
                        </div>
                        <div class="form-group" *ngIf="!isNew">
                            <div class="row">
                                <div class="col-md-6">
                                    <a class="btn btn-primary" routerLink="/account/login">
                                        Login <i class="fa fa-arrow-right" aria-hidden="true"></i>
                                    </a>
                                </div>
                            </div>
                        </div>

                    </form>
                </div>

            </div>
        </div>
    </div>
</div>